const ATHENA_CONFIG = {
    clientId: process.env.REACT_APP_CLIENT_ID,
    clientSecret: process.env.REACT_APP_CLIENT_SECRECT,
    apiVersion: 'v1',
    practiceId: process.env.REACT_APP_PRACTICE_ID,
    baseUrl: 'https://api.preview.platform.athenahealth.com',
    tokenUrl: 'https://api.preview.platform.athenahealth.com/oauth2/v1/token'
};

const environments = {
    sandbox: {
        baseUrl: `${ATHENA_CONFIG.baseUrl}/${ATHENA_CONFIG.apiVersion}`,
        authUrl: ATHENA_CONFIG.tokenUrl,
        practiceId: ATHENA_CONFIG.practiceId,
    },
    preview: {
        baseUrl: `${ATHENA_CONFIG.baseUrl}/${ATHENA_CONFIG.apiVersion}`,
        authUrl: ATHENA_CONFIG.tokenUrl,
        practiceId: ATHENA_CONFIG.practiceId,
    },
    production: {
        baseUrl: `${ATHENA_CONFIG.baseUrl.replace('preview.', '')}/${ATHENA_CONFIG.apiVersion}`,
        authUrl: ATHENA_CONFIG.tokenUrl.replace('preview.', ''),
        practiceId: '', // To be filled when going to production
    },
};

export { environments };
export default ATHENA_CONFIG;
